import { useStaticQuery, graphql } from "gatsby"

import { sanitizeForDisplay } from "../utils/general"

const query = graphql`
  query AtcAreaDescriptionQuery {
    allContentfulAtcAreaDescription {
      edges {
        node {
          uid
          title
          copy
          description {
            description
          }
          points {
            points
          }
        }
      }
    }
  }
`

export const useContentfulAtcAreaDescription = (uid) => {
  const data = useStaticQuery(query)

  //console.log("useContentfulAtcAreaDescription", uid, data)

  const foundNode =
    data?.allContentfulAtcAreaDescription?.edges?.find(
      ({ node }) => node.uid === uid
    )?.node ?? null

  if (foundNode) {
    const description = foundNode.description?.description || ""
    return {
      ...foundNode,
      description: sanitizeForDisplay(description),
      title: sanitizeForDisplay(foundNode.title),
      copy: sanitizeForDisplay(foundNode.copy),
      points: foundNode.points?.points
        ? foundNode.points.points.split("\n")
        : [],
      //backward compatibility hgn and duos
      subtitle: foundNode.subtitle || description,
      headline: foundNode.headline || foundNode.title,
    }
  } else {
    throw new Error(`useContentfulAtcAreaDescription->No data found for ${uid}`)
  }
}
